// polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
// libraries
import Vue from "vue";
import App from "@/Tests.vue";
import router from "@/router/tests";
import store from "@/store";
import i18n from "@/i18n";
import "bootstrap";
import "@/configuration";
import "@/mixins";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app");
